import { MenuItem, TextField } from "@mui/material";
import { SelectHTMLAttributes, useEffect, useState } from "react";

interface Option {
  value: string | number;
  label: string;
}

interface EdSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  id: string;
  options: Option[];
  register?: any;
  error?: String;
  icon?: any;
  placeholder?: string;
  value?: string | number;
  disabled?: boolean;
  /** Callback quando la dropdown si apre */
  onOpen?: () => void;
  /** Mostra loading spinner */
  loading?: boolean;
}


export default function EdSelect({
  label,
  id,
  options,
  register,
  error,
  icon,
  placeholder,
  value,
  disabled,
  onOpen,
  loading,
  ...props
}: EdSelectProps) {
  const [localError, setLocalError] = useState(error);

  useEffect(() => {
    setLocalError(error);
  }, [error]);

  const { onChange: registerOnChange, ...restRegister } = register || {};

  return (
    <TextField
      select
      id={id}
      label={label}
      value={value || ""}
      error={!!localError}
      helperText={localError}
      disabled={disabled || loading}
      SelectProps={{
        onOpen: onOpen,
      }}
      onChange={(e) => {

        if (registerOnChange) {
          registerOnChange(e);
        }
        setLocalError(undefined);
      }}
      sx={{
        backgroundColor: "white",
        "& .MuiFormLabel-root": {
          marginTop: "-8px",
        },
        "& .MuiInputLabel-shrink":{
          marginTop: "0px",
        },
        "& .MuiSelect-select": {
          padding: "8px 14px",
          display: "flex",
          border: "2px solidblack",
          items: "center",
        },

      }}
      fullWidth
      InputProps={{
        startAdornment: icon && (
          <span className="pr-2 border-r border-r-secondaryColor-400">
            {icon}
          </span>
        ),
      }}
      {...restRegister}
      {...props}
    >
      {placeholder && (
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
      )}
      {options?.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
} 